// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__11BY3","large":"styles_large__26TgV"};